<template>
  <v-form>
    <TituloPagina :titulo="tituloDaPagina" />
    <v-textarea
      v-model.trim="observacoes"
      auto-grow
      auto-focus
      counter
      :counter-value="() => observacoes.length"
      solo
      maxlength="500"
      class="mt-3"
      data-cy="reembolso_observacoes"
      :placeholder="placeholder"
      :row-height="54"
      :rows="5"
      :error-messages="errorObservacoes"
    />

    <v-alert
      v-if="boletoParcelado"
      class="mt-3"
      color="warning"
      dark
      dense
    >
      <strong>Importante</strong><br>
      Para receber de volta as parcelas pagas, envie os comprovantes de pagamento.
      Sem eles iremos apenas cancelar a compra sem efetuar reembolso.
    </v-alert>

    <v-file-input
      v-model="anexos"
      data-cy="reembolso_anexos"
      multiple
      solo
      flat
      height="56px"
      accept="image/jpeg, image/png, application/pdf"
      :label="labelAnexos"
      :show-size="1000"
      :counter="numeroMaximoAnexos"
      :error-messages="errorAnexosMessages"
      :error="errorAnexos"
      :messages="mensagemAnexos"
      prepend-icon=""
      class="my-3"
    >
      <template v-slot:label>
        <v-icon>mdi-paperclip</v-icon>
        {{ labelAnexos }}
      </template>
    </v-file-input>
  </v-form>
</template>

<script>

import { required, minLength } from 'vuelidate/lib/validators';
import TituloPagina from '@/components/TituloPagina.vue';

export default {

  name: 'PassoSobreReembolso',

  components: {
    TituloPagina,
  },

  props: {
    boletoParcelado: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    observacoes: '',
    placeholder: 'Observações',
    anexos: [],
    invalidObservacoes: ['Por favor, preencha pelo menos 25 caracteres.'],
    errorAnexosMessages: [],
    errorAnexos: false,
    tituloDaPagina: 'Sobre o reembolso',
  }),

  computed: {
    errorObservacoes() {
      let errors = [];
      if (this.$v.observacoes.$dirty && this.$v.observacoes.$invalid) {
        errors = this.invalidObservacoes;
      }

      return errors;
    },

    labelAnexos() {
      return this.boletoParcelado
        ? 'Anexe os comprovantes de pagamento'
        : 'Insira até 3 imagens';
    },

    numeroMaximoAnexos() {
      return this.boletoParcelado
        ? 6
        : 3;
    },

    mensagemAnexos() {
      return this.boletoParcelado
        ? 'Você pode enviar até 6 arquivos'
        : '';
    },
  },

  watch: {
    observacoes() {
      this.$v.observacoes.$touch();
      this.enviarDados();
    },

    anexos() {
      this.validacaoInputFile();
      this.enviarDados();
    },
  },

  methods: {
    validacaoInputFile() {
      const arquivos = this.anexos;

      if (!arquivos) {
        return;
      }

      const errorMessages = [];

      if (arquivos.length > this.numeroMaximoAnexos) {
        errorMessages.push(`Por favor, insira no máximo ${this.numeroMaximoAnexos} imagens.`);
      }

      if (arquivos.some(file => file.size > 5000000)) {
        errorMessages.push('Por favor, insira arquivos de no máximo 5MB.');
      }

      const extensoesAceitas = ['jpg', 'jpeg', 'png', 'pdf'];
      const extensaoAceita = arquivos.every((file) => {
        const partesArquivo = file.name.split('.');
        const extensao = partesArquivo[partesArquivo.length - 1].toLowerCase();
        return extensoesAceitas.includes(extensao);
      });

      if (arquivos.length && !extensaoAceita) {
        errorMessages.push('Por favor, insira arquivos com as extensões: jpg, jpeg, png ou pdf.');
      }

      this.errorAnexosMessages = errorMessages;
      this.errorAnexos = errorMessages.length > 0;
    },

    enviarDados() {
      const anexoValido = !this.errorAnexos;
      const observacoesValido = !this.$v.observacoes.$invalid;

      this.$emit('formValidado', {
        validado: observacoesValido && anexoValido,
        form: {
          observacoes: this.observacoes,
          anexos: this.anexos,
        },
      });
    },
  },

  validations: {
    observacoes: {
      required,
      minLength: minLength(25),
    },
  },

};
</script>

<style lang="scss">
  .v-input .v-label{
    height: 23px;
  }
</style>
